import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
// Admin pages

import store from '../store'

import SigninPage from '../components/auth/signin.vue'
import WestNileVirus from "@/pages/WestNileVirus";
import Home from "@/pages/home";
import MosquitoBorneDieseasesRiskPredictions from "@/pages/MosquitoBorneDieseasesRiskPredictions";
import CulexMosquitoesAbundance from "@/pages/CulexMosquitoesAbundance";
import AedesMosquitoesAbundance from "@/pages/AedesMosquitoesAbundance"
import AnophelesMosquitoesAbundance from "@/pages/AnophelesMosquitoesAbundance"
import SettlementWestNileVirus from "@/pages/SettlementWestNileVirus";
import WestNileVirus_Municipality from "@/pages/WestNileVirus_Municipality";
import Profile from "@/pages/Profile";
import axios from "../axios-auth";

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: SigninPage,

  },

  {
    path: '/dashboard',
    component: DashboardLayout,
    redirect: '/dashboard/EntomologicalData',
    children: [
      {
        path: 'EntomologicalData',
        name: 'Overview',
          component: Home,
          
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Entomological Data'})
         
          testAuth(next)
        }
      },
      {
        path: 'MosquitoBorneDieseasesRiskPredictions',
        name: 'MosquitoBorneDieseasesRiskPredictions',
          component: MosquitoBorneDieseasesRiskPredictions,
          
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Mosquito Borne Diseases Risk Predictions'})
         
          testAuth(next)
        }
      },
     {
        path: 'WestNileVirus',
        name: 'WestNileVirus',
        component: WestNileVirus,
       beforeEnter (to, from, next) {
        store.dispatch('pageName',{name:'Epidemiological Data / West Nile Virus'})
         testAuth(next)
       }
      },
      {
        path: 'Mosquitoes-Abundance/Culex',
        name: 'Mosquitoes-Abundance',
        component: CulexMosquitoesAbundance,
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Mosquitoes` Abundance Predictions / Culex'})
          console.log(store.getters.PageName)
          testAuth(next)
        }

      },
      {
        path: 'Mosquitoes-Abundance/Aedes',
        name: 'Mosquitoes-Abundance',
        component: AedesMosquitoesAbundance,
        beforeEnter (to, from, next) {
          console.log('here!!')
          store.dispatch('pageName',{name:'Mosquitoes` Abundance Predictions / Aedes'})
          console.log(store.getters.PageName)
          testAuth(next)
        }

      },
      {
        path: 'Mosquitoes-Abundance/Anopheles',
        name: 'Mosquitoes-Abundance',
        component: AnophelesMosquitoesAbundance,
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Mosquitoes` Abundance Predictions / Anopheles'})
      
          testAuth(next)
        }

      },
      {
        path: 'West-Nile-Virus/Settlement',
        name: 'SettlementWestNileVirus',
        component: SettlementWestNileVirus,
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Human Cases Risk Predictions / West Nile Virus / Settlement Level'})
      
          testAuth(next)
        }
      },
      {
        path: 'West-Nile-Virus/Municipality',
        name: 'WestNileVirus_Municipality',
        component: WestNileVirus_Municipality,
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Human Cases Risk Predictions / West Nile Virus / Municipality Level'})
      
          testAuth(next)
        }
      },
      {
        path: 'Profile',
        name: 'Profile',
        component: Profile,
        beforeEnter (to, from, next) {
          store.dispatch('pageName',{name:'Profile'})
      
          testAuth(next)
        }
      },
      /*
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      }
    */
    ]
  },
  { path: '*', component: NotFound }
]

 async function testAuth(next){
  if (store.getters.isAuthenticated) {
    next()
  } else {
    //var token=localStorage.getItem('token')
    //console.log(token)
   // const reToken=localStorage.getItem('retoken')
    const username = localStorage.getItem('username')
    //console.log(idToken)
    //globalAxios.get('https://login-6e465-default-rtdb.firebaseio.com/users.json' + '?auth=' + idToken)
   /*  axios.post('http://127.0.0.1:8000/api-token-refresh/', {
      refresh: reToken,
    })
      .then(response => {
        // console.log("here"+response)
        localStorage.setItem('token', response.data.access)
        //localStorage.setItem('token', response.data.access)
        //localStorage.setItem('retoken', response.data.refresh)


      })

    */

    var token=localStorage.getItem('token')

     axios.post('/verifytoken/',{ token: token })
      .then(response => {
        axios.get('user',{ headers: { Authorization: 'Bearer ' + token }}).then(async function(response){
          //console.log('user',response)
          localStorage.setItem("user", JSON.stringify(response.data));
          await store.dispatch('fetchUser')
          next()
        })
      })
       .catch(err => {
          next( '/' )
         store.dispatch('logout')
       console.log(err)
     })
    //console.log(token)
    /*axios.get('http://127.0.0.1:8000/user/'+ username, { headers: { Authorization: `Bearer ${token}`} })
      .then(response => {

        next()
        //console.log(response)
      })
      .catch(err => {
        next( '/signin' )
        console.log(err)
      })

     */

  }
}

export default new VueRouter({mode: 'history', routes, linkActiveClass: 'nav-item active'})
